import { useAdminAuthorized } from 'innovate/api/api';
import Loader from 'innovate/components/common/Loader';
import ApprovalProvider from 'innovate/components/ApprovalProvider';
import { lazy, ReactNode, Suspense } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { AdminLayout } from './pages/AdminPages/AdminLayout';

const Dashboard = lazy(() => import('./pages/AdminPages/Dashboard'));
const UsersList = lazy(() => import('./pages/AdminPages/Users'));
const PendingRequests = lazy(() => import('./pages/AdminPages/PendingRequests'));
const ObppcHistory = lazy(() => import('./pages/AdminPages/ObppcHistory'));
const ChangeRequests = lazy(() => import('./pages/AdminPages/ChangeRequests'));
const RequestAdmin = lazy(() => import('./pages/AccessRequest/RequestAdmin'));
const Scenarios = lazy(() => import('./pages/AdminPages/Scenarios'));
const NotFoundPage = lazy(() => import('./pages/Unauthorized/NotFoundPage'));

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAdmin, isLoading } = useAdminAuthorized();

  const navigate = useNavigate();

  if (isLoading) {
    return <Loader dH="90vh" dW="20vw" />;
  }

  if (!isAdmin) {
    navigate('/404', {
      state: { apiEndpoint: 'admin', status: '404' },
    });
    return null;
  }

  return children;
};

// Layout wrapper component
const AdminLayoutWrapper = () => {
  return (
    <ProtectedRoute>
      <ApprovalProvider>
        <AdminLayout>
          <Suspense fallback={<Loader dH="90vh" dW="20vw" />}>
            <Outlet />
          </Suspense>
        </AdminLayout>
      </ApprovalProvider>
    </ProtectedRoute>
  );
};

const adminRoutes = [
  {
    path: 'admin',
    element: <AdminLayoutWrapper />,
    children: [
      {
        index: true,
        Component: Dashboard,
      },
      {
        path: 'users',
        Component: UsersList,
      },
      {
        path: 'pending-requests',
        Component: PendingRequests,
      },
      {
        path: 'obppc-history',
        Component: ObppcHistory,
      },
      {
        path: 'change-requests',
        Component: ChangeRequests,
      },
      {
        path: 'create-user',
        Component: RequestAdmin,
      },
      {
        path: 'edit-user',
        Component: RequestAdmin,
      },
      {
        path: 'scenarios',
        Component: Scenarios,
      },
      {
        path: 'scenarios/pinned',
        Component: Scenarios,
      },
      {
        path: 'scenarios/active',
        Component: Scenarios,
      },
      {
        path: 'scenarios/deleted',
        Component: Scenarios,
      },
      {
        path: '*',
        Component: NotFoundPage,
      },
    ],
  },
];

export default adminRoutes;
